import { call, put, select, takeLatest } from 'redux-saga/effects';

import { supplierMaterialsService } from 'services/materialService';

import {
  removeSupplierMaterial,
  receiveMaterialSelectorSettings,
} from 'store/materials/actions';
import { initMaterialStore } from 'store/materials/sagas';
import { getGroupId } from 'store/session/selectors';

import {
  actionModal,
  deleteSupplierMaterial,
  excludedMaterialDrawer,
  types,
  updateMaterialSelectorSettings,
  uploadSupplierMaterials,
} from './actions';

export default function* root() {
  yield takeLatest(
    types.UPLOAD_SUPPLIER_MATERIALS_REQUEST,
    watchUploadSupplierMaterialsCsv,
  );
  yield takeLatest(
    types.DELETE_SUPPLIER_MATERIAL_REQUEST,
    watchDeleteSupplierMaterial,
  );
  yield takeLatest(
    types.UPDATE_MATERIAL_SELECTOR_SETTINGS_REQUEST,
    watchUpdateMaterialSelectorSettings,
  );
}

function* watchUploadSupplierMaterialsCsv({ payload }) {
  const groupId = yield select(getGroupId);
  try {
    yield call(supplierMaterialsService.uploadCsv, groupId, payload);
    yield put(uploadSupplierMaterials.success());
    yield put(actionModal.close());
    yield call(initMaterialStore);
  } catch (error) {
    yield put(uploadSupplierMaterials.error(error));
  }
}

function* watchDeleteSupplierMaterial({ payload }) {
  const { supplierMaterialId } = payload;
  try {
    yield call(supplierMaterialsService.delete, supplierMaterialId);
    yield put(removeSupplierMaterial({ supplierMaterialId }));
    yield put(deleteSupplierMaterial.success());
  } catch (error) {
    yield put(deleteSupplierMaterial.error(error));
  }
}

function* watchUpdateMaterialSelectorSettings({ payload }) {
  const groupId = yield select(getGroupId);
  try {
    const response = yield call(
      supplierMaterialsService.updateMaterialSelectorSettings,
      groupId,
      payload,
    );
    yield put(receiveMaterialSelectorSettings({ selectorSettings: response }));
    yield put(excludedMaterialDrawer.closeAll());
    yield put(updateMaterialSelectorSettings.success());
  } catch (error) {
    yield put(updateMaterialSelectorSettings.error(error));
  }
}
